import { ToastContainer, Zoom } from "react-toastify";
import { IconContext } from "@phosphor-icons/react";

import { medplumClient } from "@/lib/medplum";
import { AppProvider } from "@/context/app-provider";
import { MedplumSessionProvider } from "@/context/medplum-provider";
import { MedplumClientProvider } from "@/context/MedplumClientProvider";

import { AppRouter } from "@/views/AppRouter";

import { ErrorBoundary } from "./components/module/ErrorBoundary";
import { ReactQueryProvider } from "./context/react-query-provider";

export const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <MedplumClientProvider medplum={medplumClient}>
        <MedplumSessionProvider>
          <ReactQueryProvider>
            <AppProvider>
              <IconContext.Provider
                value={{
                  size: 24,
                  mirrored: false,
                }}
              >
                <AppRouter />
              </IconContext.Provider>
              <ToastContainer
                closeButton={false}
                draggable={false}
                hideProgressBar
                pauseOnFocusLoss={false}
                position="top-center"
                autoClose={3000}
                closeOnClick
                transition={Zoom}
                icon={false}
                limit={3}
              />
            </AppProvider>
          </ReactQueryProvider>
        </MedplumSessionProvider>
      </MedplumClientProvider>
    </ErrorBoundary>
  );
};
